export default __webpack_public_path__ + "static/media/call.a1eeb7d7.png";